export const usersDetails = [
    {  
		checkbox: true,
		name: "Anthony Lewis",
		image_url:"assets/img/users/user-32.jpg",
		email: "anthony@example.com",
		created_date: "12/09/2024",
		role:"Employee",
		status:"Active",
        key:1
	},
	{   
		checkbox: true,
		name: "Brian Villalobos",
		image_url:"assets/img/users/user-09.jpg",
		email: "brian@example.com",
		created_date: "24/10/2024",
		role:"Employee",
		status:"Active",
        key:2
	},
	{
		checkbox: true,
		name: "Sophie Headrick",
		image_url:"assets/img/users/user-19.jpg",
		email: "sophie@example.com",
		created_date: "18/02/2024",
		role:"Client",
		status:"Active",
        key:3
	},
	{
		checkbox: true,
		name: "Stephan Peralt",
		image_url:"assets/img/users/user-33.jpg",
		email: "peral@example.com",
		created_date: "17/10/2024",
		role:"Employee",
		status:"Active",
        key:4
	},
	{
		checkbox: true,
		name: "Thomas Bordelon",
		image_url:"assets/img/users/user-08.jpg",
		email: "thomas@example.com",
		created_date: "20/07/2024",
		role:"Client",
		status:"Active",
        key:5
	},
	{
		checkbox: true,
		name: "Doglas Martini",
		image_url:"assets/img/users/user-34.jpg",
		email: "martniwr@example.com",
		created_date: "10/04/2024",
		role:"Employee",
		status:"Active",
        key:6
	},
	{
		checkbox: true,
		name: "Cameron Drake",
		image_url:"assets/img/users/user-03.jpg",
		email: "cameron@example.com",
		created_date: "29/08/2024",
		role:"Client",
		status:"Active",
        key:7
	},
	{
		checkbox: true,
		name: "Harvey Smith",
		image_url:"assets/img/users/user-01.jpg",
		email: "harvey@example.com",
		created_date: "22/02/2024",
		role:"Employee",
		status:"Inactive",
        key:8
	},
	{
		checkbox: true,
		name: "Michael Walker",
		image_url:"assets/img/users/user-16.jpg",
		email: "michael@example.com",
		created_date: "03/11/2024",
		role:"Client",
		status:"Active",
        key:9
	},
	{
		checkbox: true,
		name: "Doris Crowley",
		image_url:"assets/img/users/user-35.jpg",
		email: "doris@example.com",
		created_date: "17/12/2024",
		role:"Client",
		status:"Active",
        key:10
	}
];
